import { useSelector } from "react-redux";

const useSelectedPlanType = () => {
    const planType = useSelector(
        state => state.HomeInsurance.quotation.personalDataForm.data.planType
    );
    return planType;
};

export default useSelectedPlanType;
